// One-shot request channel: EditableNote's in-editor link click popover
// (spec 8b) needs its "Edit" action to open ContextMenu.jsx's EXISTING
// NoteLinkMenu (the URL-input + Apply submenu already wired to the
// toolbar's own Link button) over a target IT captured itself
// (beginLinkTargetForAnchor, over the clicked <a>'s full extent) — a
// capture ContextMenu's own Link-button onClick handler has no way to know
// about, since that handler only ever captures the LIVE Selection.
//
// EditableNote and ContextMenu are SIBLINGS under Canvas.jsx with nothing
// already plumbed between them in this direction: noteEditorBridge.js (this
// same folder) runs the OPPOSITE way — a mounted editor's imperative API,
// read INTO by ContextMenu. Same "no redux, no shared parent state"
// reasoning as NoteLinkPreview/noteLinkHoverStore.js: this is a local,
// one-shot UI request nothing else in the app cares about, never
// persisted/collaborative/undoable — a second listener slot would be
// over-engineering (exactly one editor can be open, and its own toolbar is
// the only possible subscriber).
let listener = null;

// ContextMenu.jsx subscribes once, for as long as it's mounted (i.e.
// whenever any element — including the note currently being edited — is
// focused; see its own call site). Symmetric subscribe/unsubscribe, so
// React StrictMode's dev-only mount -> cleanup -> mount double-invoke
// self-heals: cleanup only clears the slot if IT is still the current
// listener (a stale earlier-effect's cleanup can't clobber a later, real
// registration), so the sequence naturally ends with the LAST mount's
// listener installed, without needing NoteLinkMenu's own repaint-on-mount
// trick (that trick compensates for PAINTED DOM state living outside React;
// this channel has no state at all to lose between mount/cleanup/mount).
export const subscribeNoteLinkEditRequest = (fn) => {
    listener = fn;
    return () => { if (listener === fn) listener = null; };
};

// EditableNote's Edit action: fires the request. Returns whether a listener
// actually consumed it (true) or the channel was empty (false, dropped) —
// should not happen in practice (ContextMenu is always mounted alongside an
// open editor, see doc above) but the caller uses this to decide whether it
// is safe to close/hand off its OWN popover: silently vanishing with no
// listener to pick up the request would leave the user with no visible
// outcome at all, so the caller keeps its own state intact on a false
// return rather than trusting this unconditionally.
export const requestNoteLinkEdit = (payload) => {
    if (!listener) return false;
    listener(payload);
    return true;
};
